/**
 * Backend base URL resolution:
 * - Local dev (localhost): REACT_APP_URL from .env.development
 * - Deployed (any server): same origin the app is served from,
 *   so the same build works on dev, stage, and prod.
 */
export const getBackendBaseUrl = () =>
    (window.location.hostname === 'localhost'
        ? process.env.REACT_APP_URL || 'http://localhost:5000'
        : window.location.origin) + '/backend'
